import { signal, WritableSignal, Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class DialogService {
  readonly dialog = inject(MatDialog);
  private dialogs = new Map<string, WritableSignal<any>>();
  constructor() {}
  openDialog(dialogId: string): void {
    if (this.dialogs.has(dialogId)) {
      const dialogSignal = this.dialogs.get(dialogId);
      if (!dialogSignal) {
        console.warn(`Dialog with id ${dialogId} is not registered.`);
        return;
      }
      const data = dialogSignal();
      if (!data.isOpen) {
        data.isOpen = true;
        dialogSignal.set(data);
        const config: MatDialogConfig = data.config || new MatDialogConfig();
        config.ariaModal = true;
        config.restoreFocus = true;
        this.dialog.open(data.component, config);
      }
    } else {
      console.warn(`Dialog with id ${dialogId} is not registered.`);
    }
  }

  registerDialog(
    dialogId: string,
    dialogComponent: any,
    config?: MatDialogConfig
  ): void {
    if (!this.dialogs.has(dialogId)) {
      this.dialogs.set(
        dialogId,
        signal({
          isOpen: false,
          component: dialogComponent,
          config,
        })
      );
    }
  }

  closeDialog(dialogId: string): void {
    if (this.dialogs.has(dialogId)) {
      const dialogSignal = this.dialogs.get(dialogId);
      if (!dialogSignal) {
        console.warn(`Dialog with id ${dialogId} is not registered.`);
        return;
      }
      const data = dialogSignal();
      if (data.isOpen) {
        data.isOpen = false;
        dialogSignal.set(data);
        this.dialog.closeAll();
      }
    } else {
      console.warn(`Dialog with id ${dialogId} is not registered.`);
    }
  }
}
